import { Section } from '~/components/common/section';
import { NextLink, Translate } from '~/i18n';
import Image from 'next/image';
// import { MenuDots } from '~/svgs';
import useBookingsList from '~/apis/useBookingsList.api';

export const RecentProducts = () => {
   const { data: Bookings } = useBookingsList({ per_page: 5 });

   return (
      <Section className="col-span-10 px-8 py-8 h-full">
         <div className="flex items-center justify-between mb-6">
            <span className="text-lg font-semibold ">
               <Translate id="dashboard:latest bookings" />
            </span>
            <NextLink href="/sales-feed" className="text-sm font-semibold hover:underline">
               <Translate id="dashboard:view all" />
            </NextLink>
         </div>
         <div className="overflow-auto">
            <table className="w-full text-sm ">
               <thead className="uppercase text-left rtl:text-right">
                  <tr>
                     <th className="text-grey-100 bg-gray-100 h-11 first:rounded-l-md last:rounded-md pl-4">
                        <Translate id="common:product" />
                     </th>
                     <th className="text-grey-100 bg-gray-100 h-11 first:rounded-md last:rounded-md">
                        <Translate id="dashboard:ordered by" />
                     </th>
                     <th className="text-grey-100 bg-gray-100 h-11 first:rounded-md last:rounded-md">
                        <Translate id="dashboard:sales" />
                     </th>
                     {/* <th className="text-grey-100 bg-gray-100 h-11 first:rounded-md last:rounded-md">
                        <Translate id="dashboard:nps" />
                     </th> */}
                     {/* <th className="text-grey-100 bg-gray-100 h-11 first:rounded-md last:rounded-md">
                        <Translate id="common:status" />
                     </th> */}
                     <th className="text-grey-100 bg-gray-100 h-11 first:rounded-l-md last:rounded-r-md">
                        <Translate id="bookings:date issued" />
                     </th>
                  </tr>
               </thead>
               <tbody className="text-left rtl:text-right">
                  {Bookings?.data?.map((booking: any, index: number) => (
                     <tr
                        key={index}
                        className="border-b border-dashed border-gray-100 last:border-none">
                        <td className="py-2 pl-4">
                           <div className="flex items-center">
                              <Image
                                 width={25}
                                 height={25}
                                 src={
                                    booking.product?.cover_image || '/images/placeholder-image.svg'
                                 }
                                 className="rounded-full object-contain"
                              />
                              <span className="text-grey-200 text-sm  ltr:ml-4 rtl:mr-4">
                                 {booking?.product?.name}
                              </span>
                           </div>
                        </td>
                        <td className="text-sm text-grey-200">{booking.customer?.name}</td>
                        <td className="text-sm text-grey-200">{booking.price}</td>
                        <td className="text-sm text-grey-200">{booking.date_issued}</td>

                        {/* <td className="font-medium text-orange-500">
                           <div className="flex items-center justify-center">
                              <img src="/icons/rating.svg" className="w-4 h-4" />
                              <span> 9.7</span>
                           </div>
                        </td> 
                        
                        {/* <td>
                           <div>
                              <button>
                                 <MenuDots />
                              </button>
                           </div>
                        </td> */}
                     </tr>
                  ))}
                  {Bookings?.data.length === 0 && (
                     <tr>
                        <td colSpan={4} className="py-6 text-grey-200 text-center">
                           <span>
                              <Translate id="bookings:no bookings" />
                           </span>
                        </td>
                     </tr>
                  )}
               </tbody>
            </table>
         </div>
      </Section>
   );
};
